import { defineStore, createPinia } from 'pinia';
import { msalInstance } from '@/msalInstance';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

export const pinia = createPinia();

export const useAuthStore = defineStore('auth', {
  state: () => ({
    account: null,
    accessToken: null,
    scopes: [`api://${import.meta.env.VITE_AZURE_CLIENT_ID_BACKEND}/custom.read`],
  }),

  actions: {
    setActiveFromCache() {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
        this.account = accounts[0];
        this.accessToken = accounts[0].idToken;
      }
    },

    async login() {
      await msalInstance.loginRedirect({
        scopes: this.scopes,
      });
    },

    async logout() {
      await msalInstance.logoutRedirect();
    },

    async getToken() {
      const account = msalInstance.getActiveAccount();
      if (!account) throw new Error('No active account found');

      try {
        const response = await msalInstance.acquireTokenSilent({
          scopes: this.scopes,
          account,
        });
        this.accessToken = response.accessToken;
        return response.accessToken;
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          await msalInstance.acquireTokenRedirect({ scopes: this.scopes });
          return '';
        }
        throw error;
      }
    },
  },
});